import React from 'react';
import PalQuizListPage from './PalQuizListPage';

const HomeworkPage = () => {
  return <PalQuizListPage title="Homework" quizType="Homework" basePath="/pal/homework" />;
};

export default HomeworkPage;
